import { UseQueryOptions, keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { MRT_PaginationState } from "material-react-table";

import {
  KeyFilter,
  KeySort,
  PageResponseCommandJournalRegularDto,
  QueryDto,
} from "@/shared/api";
import { useApi } from "@/shared/api/use-api";

export const useCommandJournalQuery = (
  {
    pagination,
    filters = new Set<KeyFilter>(),
    sort = [],
  }: {
    pagination?: MRT_PaginationState;
    filters?: Set<KeyFilter>;
    sort?: KeySort[];
  },
  queryOptions?: Omit<
    UseQueryOptions<AxiosResponse<PageResponseCommandJournalRegularDto>>,
    "queryKey"
  >
) => {
  const { commandJournalApi } = useApi();

  return useQuery({
    queryKey: ["/command-journal", pagination, filters, sort],
    queryFn: ({ signal }) => {
      const query: QueryDto = {
        page: pagination
          ? { page_number: pagination.pageIndex, page_size: pagination.pageSize }
          : undefined,
        filters: filters,
        sort: sort,
      };
      return commandJournalApi.getCommandJournalList(query, { signal });
    },
    placeholderData: keepPreviousData,
    ...queryOptions,
  });
};
